module.exports = __webpack_public_path__ + "static/img/manual_zh_34.5b8b083.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_34.png
// module id = xK5G
// module chunks = 4